require('dotenv').config()
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import storeInit from './store/'
import vuetify from './plugins/vuetify'
import FlagIcon from 'vue-flag-icon'
import VueLogger from 'vuejs-logger'
import VueI18n from 'vue-i18n'
import en from './lang/en'
import de from './lang/de'
import fr from './lang/fr'
import nl from './lang/nl'
import sv from './lang/sv'
import tr from './lang/tr'
import ru from './lang/ru'
import ar from './lang/ar'
import pl from '@/lang/pl'
import uk from '@/lang/uk'
import it from '@/lang/it'

import * as actions from './store/action-types'
import { defaultLocale, unleashConfig, unleashEnabled } from './app.config'
const VueKeyCloak = () => import('@dsb-norge/vue-keycloak-js')
import '@mdi/font/css/materialdesignicons.css'
import { disableKeycloakAuthorization, keycloakConfig } from '@/app.config'
import { initUnleash } from './unleash'
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/de'
import 'dayjs/locale/nl'
import 'dayjs/locale/se'
import 'dayjs/locale/fr'
import 'dayjs/locale/uk'
import 'dayjs/locale/es'
import 'dayjs/locale/ru'
import 'dayjs/locale/tr'
import 'dayjs/locale/es'
import 'dayjs/locale/ar'
import 'dayjs/locale/pl'
import 'dayjs/locale/it'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

Vue.filter('formatDate', function(value) {
  if (value) {
    return dayjs(String(value)).format('MM/DD/YYYY hh:mm')
  }
})

let userLang = defaultLocale
if (process.env.VUE_APP_USE_USER_LOCALE === '1') {
  userLang = navigator.language || navigator.userLanguage
}

const isProduction = process.env.NODE_ENV === 'production'

const logOptions = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
}
Vue.use(VueLogger, logOptions)

Vue.use(VueI18n)

const messages = {
  en: en,
  de: de,
  fr: fr,
  nl: nl,
  sv: sv,
  uk: uk,
  es: en,
  tr: tr,
  pl: pl,
  ru: ru,
  ar: ar,
  it: it
}

Vue.config.productionTip = false
Vue.use(FlagIcon)

const createVue = () => {
  const store = storeInit()
  store.commit(actions.SET_LANGUAGE, userLang)
  const i18n = new VueI18n({
    locale: store.state.language,
    fallbackLocale: 'de',
    messages: messages,
    dateTimeFormats: {
      en: {
        short: {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        },
        long: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          weekday: 'short',
          hour: 'numeric',
          minute: 'numeric',
          hour12: true
        }
      },
      de: {
        short: {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        },
        long: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          weekday: 'short',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        }
      }
    }
  })

  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
  }).$mount('#app')

  if (unleashEnabled === '1') {
    initUnleash(store)
  } else {
    store.dispatch(actions.UNLEASH_INIT).then(r => null)
  }
  global.log = Vue.$log
  return i18n
}
let i18nInstance
if (disableKeycloakAuthorization !== '1') {
  Vue.use(VueKeyCloak, {
    config: keycloakConfig,
    init: {
      onLoad: 'check-sso',
      enableLogging: false,
      silentCheckSsoRedirectUri:
        window.location.origin + '/silent-check-sso.html',
      checkLoginIframe: true,
      checkLoginIframeInterval: 5
    },
    onReady: k => {
      global.keycloak = k

      // listen to Single Sign-out, aka external logout events or expired sessions
      k.onAuthLogout = () => {
        window.location.reload()
      }

      // createVue()
      i18nInstance = createVue()
    },
    onInitError: err => {
      console.log('error', err)
    }
  })
} else {
  // createVue()
  i18nInstance = createVue()
}

export { i18nInstance }
